import { CustomCollapseCard, CustomForm, CustomFormItem, Text, useText } from '@src/components';
import '@src/styles/pendingApproval/processType.scss';
import { Form, Radio } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setIsApproved, setProcessType } from '@src/store/slice/packagesSlice';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ProcessType = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { processType, isApproved } = useSelector((state) => state.packages);
  const initialType = useLocation()?.search?.toString().split('=')[1];
  const { notificationList } = useSelector((state) => state?.notifications);

  useEffect(() => {
    if (processType !== 0 || processType !== 4) {
      dispatch(setIsApproved(false));
    }
    form.setFieldsValue({
      processType: processType,
    });
  }, [processType]);

  useEffect(() => {
    form.setFieldsValue({
      processTypeApproval: isApproved,
    });
  }, [isApproved]);

  useEffect(() => {
    const typeMap = {
      loadBalanceOrders: 5,
      cardOrderOrders: 6,
      autoLoadingInstructions: 4,
      deliveryConfirmations: 2,
      tMarketDeliveryConfirmations: 8,
      tCarCardOrderOrders: 3,
      cardsWaitingForMobilePaymentAuthorization: 1,
      tGiftDeliveryConfirmations: 7,
      tMarketLoadBalanceOrders: 9,
      tMarketCardOrderOrders: 10,
    };
    const selectedType = initialType ? typeMap[initialType] ?? 0 : 0;
    dispatch(setProcessType(selectedType));
  }, [initialType, dispatch]);

  return (
    <CustomCollapseCard
      className="process-type-card"
      cardTitleAlign="center"
      cardTitle={<Text t="transactionType" />}
    >
      <CustomForm
        name="processTypeForm"
        className="process-type-form"
        autoComplete="off"
        initialValues={{
          processTypeApproval: false,
        }}
        layout={'horizontal'}
        form={form}
      >
        <CustomFormItem label={false} name="processType" className="process-type-form-item">
          <Radio.Group
            id="pendingApproval-processType-processType-radioGroup"
            onChange={(val) => dispatch(setProcessType(val?.target?.value))}
            className="custom-radio-process-type"
          >
            <Radio id="pendingApproval-processType-all-radio" value={0} className="card-radio">
              <div className="card-label">
                <Text t="allPendingApprovalTransactions" />
              </div>
            </Radio>
            {notificationList.some((item) => item?.type === 1) && (
              <Radio
                id="pendingApproval-processType-balance-order-radio"
                value={1}
                className="card-radio"
              >
                <div className="card-label">
                  <Text t="mobilePayment2" />
                  <br />
                  <Text t="permissionApproval" />
                </div>
              </Radio>
            )}
            {notificationList.some((item) => item?.type === 2) && (
              <Radio
                id="pendingApproval-processType-card-approval-radio"
                value={2}
                className="card-radio"
              >
                <div className="card-label">
                  <Text t="ticketRestaurantHeader" />
                  <br />
                  <Text t="cardDeliveryConfirmation" />
                </div>
              </Radio>
            )}
            {notificationList.some((item) => item?.type === 8) && (
              <Radio
                id="pendingApproval-processType-tMarket-delivery-confirmations-radio"
                value={8}
                className="card-radio"
              >
                <div className="card-label">
                  <Text t="ticketMarketHeader" />
                  <br />
                  <Text t="cardDeliveryConfirmation" />
                </div>
              </Radio>
            )}
            {notificationList.some((item) => item?.type === 3) && (
              <Radio
                id="pendingApproval-processType-ticket-car-fuel-radio"
                value={3}
                className="card-radio"
              >
                <div className="card-label">
                  <Text t="ticketCarFuel" />
                  <br />
                  <Text t="cardDeliveryConfirmation2" />
                </div>
              </Radio>
            )}
            {notificationList.some((item) => item?.type === 4) && (
              <Radio
                id="pendingApproval-processType-auto-order-radio"
                value={4}
                className="card-radio"
              >
                <div className="card-label">
                  <Text t="automaticLoading" />
                  <br />
                  <Text t="instructionApproval" />
                </div>
              </Radio>
            )}
            {notificationList.some((item) => item?.type === 5) && (
              <Radio
                id="pendingApproval-processType-balance-order-radio"
                value={5}
                className="card-radio"
              >
                <div className="card-label">
                  <Text t="ticketRestaurantHeader" />
                  <br />
                  <Text t="balanceOrderApproval" />
                </div>
              </Radio>
            )}
            {notificationList.some((item) => item?.type === 6) && (
              <Radio
                id="pendingApproval-processType-card-order-radio"
                value={6}
                className="card-radio"
              >
                <div className="card-label">
                  <Text t="ticketRestaurantHeader" />
                  <br />
                  <Text t="newCardOrderConfirmation" />
                </div>
              </Radio>
            )}
            {notificationList.some((item) => item?.type === 7) && (
              <Radio
                id="pendingApproval-processType-ticket-car-fuel-radio"
                value={7}
                className="card-radio"
              >
                <div className="card-label">
                  <Text t="ticketGiftCardDeliveryConfirmation" />
                </div>
              </Radio>
            )}
            {notificationList.some((item) => item?.type === 9) && (
              <Radio
                id="pendingApproval-processType-ticket-car-fuel-radio"
                value={9}
                className="card-radio"
              >
                <div className="card-label">
                  <Text t="ticketMarketHeader" />
                  <br />
                  <Text t="balanceOrderApproval" />
                </div>
              </Radio>
            )}
            {notificationList.some((item) => item?.type === 10) && (
              <Radio
                id="pendingApproval-processType-ticket-car-fuel-radio"
                value={10}
                className="card-radio"
              >
                <div className="card-label">
                  <Text t="ticketMarketHeader" />
                  <br />
                  <Text t="newCardOrderConfirmation" />
                </div>
              </Radio>
            )}
          </Radio.Group>
        </CustomFormItem>
      </CustomForm>
    </CustomCollapseCard>
  );
};

export default ProcessType;
